import logo from 'assets/images/logo.svg';

const LogoMain = () => {

  return (
    <img src={logo} alt="icon logo" width="150" />

  );
};

export default LogoMain;
